import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const TechRadar: Site = {
  id: 'techradar',
  logo: 'svg/techradar.svg',
  favicon: 'svg/techradar-favicon.svg',
  label: 'TechRadar',
  analyticsName: 'trd',
  hostname: 'techradar.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
